<template>
<!-- 测评列表 -->
  <div>
    <div class="banner">
      <img :src="bannerImg">
      <div class="title">生涯测评</div>
    </div>
    <div class="evaluation-page">
      <div class="evaluation-list" v-loading.fullscreen.lock="fullscreenLoading">
        <div class="list-section" v-for="(item, index) in listData" :key='index'>
          <div class="item-img" v-if="item.testImage"><img :src="item.testImage"></div>
          <div class="item-content">
            <div class="item-title p-t-15"><span v-text="item.testName">更多介绍标题</span></div>
            <div class="item-text p-t-15" v-if="item.testIntroduction">
              <span>{{item.testIntroduction | filterIntroduction}}</span>
            </div>
            <div class="p-t-15 btn-box">
              <div>
                <span>共 <span class="txt-blue">{{item.questionsNum}}</span> 题</span>
                <span class="m-l-15">约 <span class="txt-blue">{{item.totalTime}}</span> 分钟</span>
              </div>
              <el-button type="primary" @click="goDetail(item.testId)">进入测评</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from "@/util/request"

export default {
  name: "evaluationList",
  data () {
    return {
      listData: [],
      fullscreenLoading: true,
      bannerImg: ''
    }
  },
  filters: {
    filterIntroduction (text) {
      let filterText = ''
      filterText = text.length > 90 ? text.substring(0, 90) + '...' : text
      return filterText
    },
    nature2CN (type) {
      return {
        1: '公办',
        2: '民办',
        3: '合办',
      }[type] || type
    },
  },
  methods: {
    getTestList () {
      request({
        method: 'get',
        url: 'mendao/v2/getTest',
        params: {
          type: 2
        }
      }).then(res => {
        if (res.code == 0) {
          this.fullscreenLoading = false;

          res.data.forEach(e => {
            e.testDescArr = JSON.parse(e.testDesc);
          })
          this.listData = res.data;
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((res) => {
      });
    },
    goDetail (testId) {
      this.$router.push({
        path: '/evaluation/detail',
        query: {
          testId: testId
        }
      })
    },
    getTestBanner () {
      request({
        method: 'get',
        url: '/index/getBanner',
        params: {
          type: 5
        }
      }).then(res => {
        if (![0, 200].includes(res.code)) {
          return this.$message.error(res.msg)
        }
        if (res.data[0]) {
          this.fullscreenLoading = false
          this.bannerImg = res.data[0].image
        }
      }).catch((res) => {
      });
    },

  },
  created () {
    this.getTestList()
    this.getTestBanner()
  }
}
</script>

<style scoped lang="stylus">
.banner
  position: relative;
  width: 100%;
  height: 260px;
  img
    display: block;
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
  .title
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -43px;
    margin-left: -100px;
    z-index: 1;
    width: 200px;
    height: 86px;
    font-size: 50px;
    //font-weight: PingFangMedium600;
    color: #FFFFFF;
    line-height: 86px;
    text-shadow: 0 4px 4px rgba(121,68,2,0.1);

pageWidth = 1440px
div
  box-sizing: border-box
.evaluation-page
  width pageWidth
  min-height 100%
  margin 0 auto
  background #fff

  .evaluation-list
    width 900px
    padding 20px 0
    margin 0 auto
    .p-t-15
      padding-top 15px
    .m-l-15
      margin-left 15px
    .txt-c
      text-align center
    .list-section
      display: flex;
      align-items: center;
      justify-items center
      border-bottom 1px solid rgba(0, 0, 0, 0.1)
      padding 15px 0

      .item-img
        width: 320px;
        img
          width: 320px;
          height: 160px;

      .item-content
        padding-left: 20px;
        flex 1

        .item-title span
          font-size: 18px;
          color: #101010;
          font-weight: 600

        .item-text
          color rgba(0, 0, 0, 0.8)
          line-height 25px
          word-break break-all

      .btn-box
        display flex
        align-items center
        justify-content space-between

        .txt-blue
          color #0000FF

    .list-section:last-child
      border-bottom 0

  .row-bg
    background: black;

</style>
